<template>
  <div class="overflow-hidden" style="height: 100%;">
    <!--门禁-->
    <div style="padding-top: 15px;font-weight: bold;margin-left: 25px;">
      <span
        style="width: 5px;height: 15px;border-left: 2px solid #299FFB;display: inline-block;margin-bottom: -2px;margin-right: 5px;"></span>
      <span>电梯运行统计</span>
    </div>
    <div style="overflow-y: auto; height: 84%;margin-top: 4%">
    <el-tabs style="margin: 10px 25px" v-model="activeId">
      <el-tab-pane label="C1栋" name="1">

        <el-row style="margin: 0 0 0 5px;font-size: 0.9rem">
          <ul style="margin-top: 5px">
            <li>
              <img src="../../../assets/images/comprehensive/门禁记录.png" style="margin-bottom: 2px;">
              <span class="ml-1 mr-1" style="font-weight: bold">C1栋电梯设备</span>
            </li>
            <li style="color: rgba(41, 159, 251, 1);font-weight: bold">
              <!--    梯控系统-->
              <span v-if="elevatorList.count > 0">
            {{ elevatorList.count ? '共' + elevatorList.count + '个' : '暂无设备' }}
          </span>
              <!--门磁信号-->
              <span v-else-if="elevatorList.data.length <= 0">
            暂无设备
          </span>
            </li>
          </ul>
        </el-row>
        <div class="h-100 overflow" style="margin-top: -15px;">
          <!--    梯控系统-->
          <el-row :key="item.id" style="margin-left: 10px; margin-top: 10px; font-size: 0.9em"
                  v-for="item in elevatorList.data">
            <div class="p-3"
                 style="width: 280px; height: 132px; border: 2px solid rgba(41, 155, 255, .2);border-radius: 5px;">
              <div style="margin-left: 20px;height: 90%; ">
                <div style="width: 65%">
                  <el-row style="margin-left: 75px ;font-size: 15px ">{{ item.card }}</el-row>
                  <el-row style="margin-top: 7px;">运行方向：{{ item.direction }}</el-row>
                  <el-row style="margin-top: 7px;">所在楼层：{{ item.number }}</el-row>
                  <el-row style="margin-top: 7px;">运行状态：<span :style="{ color: item.status === 'ok' ? 'rgba(0, 212, 136,1)' :
               item.status=== 'error' ? 'rgba(249, 84, 83, 1)': 'rgba(249, 227, 83, 1)' }">{{item.pointValue}}</span></el-row>
                </div>
                <img v-if=" item.status === 'ok' && item.direction === '上行'" src="../../../assets/images/comprehensive/elnormalUp.png"
                     style="margin: -90px 0px 0px 170px; ">
                <img v-if=" item.status === 'ok' && item.direction === '下行'" src="../../../assets/images/comprehensive/elevatorDonw.png"
                     style="margin: -90px 0px 0px 170px; ">
                <img v-if="item.status === 'error' " src="../../../assets/images/comprehensive/elreport.png"
                     style="margin: -90px 0px 0px 170px; ">
                <img v-if="item.status === 'maintain' " src="../../../assets/images/comprehensive/elmaintain.png"
                     style="margin: -90px 0px 0px 170px; ">
              </div>

            </div>
          </el-row>
        </div>
      </el-tab-pane>
      <el-tab-pane label="C2栋" name="2">
        <el-row style="margin: 0 0 0 5px;font-size: 0.9rem">
          <ul style="margin-top: 5px">
            <li>
              <img src="../../../assets/images/comprehensive/门禁记录.png" style="margin-bottom: 2px;">
              <span class="ml-1 mr-1" style="font-weight: bold">C1栋电梯设备</span>
            </li>
            <li style="color: rgba(41, 159, 251, 1);font-weight: bold">
              <!--    梯控系统-->
              <span v-if="elevatorList.count > 0">
            {{ elevatorList.count ? '共' + elevatorList.count + '个' : '暂无设备' }}
          </span>
              <!--门磁信号-->
              <span v-else-if="elevatorList.data.length <= 0">
            暂无设备
          </span>
            </li>
          </ul>
        </el-row>
        <div class="h-100 overflow" style="margin-top: -15px;">
          <!--    梯控系统-->
          <el-row :key="item.id" style="margin-left: 10px; margin-top: 10px; font-size: 0.9em"
                  v-for="item in elevatorList2.data">
            <div class="p-3"
                 style="width: 280px; height: 132px; border: 2px solid rgba(41, 155, 255, .2);border-radius: 5px;">
              <div style="margin-left: 20px;height: 90%; ">
                <div style="width: 65%">
                  <el-row style="margin-left: 75px ;font-size: 15px ">{{ item.card }}</el-row>
                  <el-row style="margin-top: 7px;">运行方向：{{ item.direction }}</el-row>
                  <el-row style="margin-top: 7px;">所在楼层：{{ item.number }}</el-row>
                  <el-row style="margin-top: 7px;">运行状态：<span :style="{ color: item.status === 'ok' ? 'rgba(0, 212, 136,1)' :
               item.status=== 'error' ? 'rgba(249, 84, 83, 1)': 'rgba(249, 227, 83, 1)' }">{{item.pointValue}}</span></el-row>
                </div>
                <img v-if=" item.status === 'ok' && item.direction === '上行'" src="../../../assets/images/comprehensive/elnormalUp.png"
                     style="margin: -90px 0px 0px 170px; ">
                <img v-if=" item.status === 'ok' && item.direction === '下行'" src="../../../assets/images/comprehensive/elevatorDonw.png"
                     style="margin: -90px 0px 0px 170px; ">
                <img v-if="item.status === 'error' " src="../../../assets/images/comprehensive/elreport.png"
                     style="margin: -90px 0px 0px 170px; ">
                <img v-if="item.status === 'maintain' " src="../../../assets/images/comprehensive/elmaintain.png"
                     style="margin: -90px 0px 0px 170px; ">
              </div>

            </div>
          </el-row>
        </div>
      </el-tab-pane>
      <el-tab-pane label="D1栋" name="3">
        <el-row style="margin: 0 0 0 5px;font-size: 0.9rem">
          <ul style="margin-top: 5px">
            <li>
              <img src="../../../assets/images/comprehensive/门禁记录.png" style="margin-bottom: 2px;">
              <span class="ml-1 mr-1" style="font-weight: bold">C1栋电梯设备</span>
            </li>
            <li style="color: rgba(41, 159, 251, 1);font-weight: bold">
              <!--    梯控系统-->
              <span v-if="elevatorList.count > 0">
            {{ elevatorList.count ? '共' + elevatorList.count + '个' : '暂无设备' }}
          </span>
              <!--门磁信号-->
              <span v-else-if="elevatorList.data.length <= 0">
            暂无设备
          </span>
            </li>
          </ul>
        </el-row>
        <div class="h-100 overflow" style="margin-top: -15px;">
          <!--    梯控系统-->
          <el-row :key="item.id" style="margin-left: 10px; margin-top: 10px; font-size: 0.9em"
                  v-for="item in elevatorList3.data">
            <div class="p-3"
                 style="width: 280px; height: 132px; border: 2px solid rgba(41, 155, 255, .2);border-radius: 5px;">
              <div style="margin-left: 20px;height: 90%; ">
                <div style="width: 65%">
                  <el-row style="margin-left: 75px ;font-size: 15px ">{{ item.card }}</el-row>
                  <el-row style="margin-top: 7px;">运行方向：{{ item.direction }}</el-row>
                  <el-row style="margin-top: 7px;">所在楼层：{{ item.number }}</el-row>
                  <el-row style="margin-top: 7px;">运行状态：<span :style="{ color: item.status === 'ok' ? 'rgba(0, 212, 136,1)' :
               item.status=== 'error' ? 'rgba(249, 84, 83, 1)': 'rgba(249, 227, 83, 1)' }">{{item.pointValue}}</span></el-row>
                </div>
                <img v-if=" item.status === 'ok' && item.direction === '上行'" src="../../../assets/images/comprehensive/elnormalUp.png"
                     style="margin: -90px 0px 0px 170px; ">
                <img v-if=" item.status === 'ok' && item.direction === '下行'" src="../../../assets/images/comprehensive/elevatorDonw.png"
                     style="margin: -90px 0px 0px 170px; ">
                <img v-if="item.status === 'error' " src="../../../assets/images/comprehensive/elreport.png"
                     style="margin: -90px 0px 0px 170px; ">
                <img v-if="item.status === 'maintain' " src="../../../assets/images/comprehensive/elmaintain.png"
                     style="margin: -90px 0px 0px 170px; ">
              </div>

            </div>
          </el-row>
        </div>
      </el-tab-pane>
      <el-tab-pane label="D2栋" name="4">
        <el-row style="margin: 0 0 0 5px;font-size: 0.9rem">
          <ul style="margin-top: 5px">
            <li>
              <img src="../../../assets/images/comprehensive/门禁记录.png" style="margin-bottom: 2px;">
              <span class="ml-1 mr-1" style="font-weight: bold">C1栋电梯设备</span>
            </li>
            <li style="color: rgba(41, 159, 251, 1);font-weight: bold">
              <!--    梯控系统-->
              <span v-if="elevatorList.count > 0">
            {{ elevatorList.count ? '共' + elevatorList.count + '个' : '暂无设备' }}
          </span>
              <!--门磁信号-->
              <span v-else-if="elevatorList.data.length <= 0">
            暂无设备
          </span>
            </li>
          </ul>
        </el-row>
        <div class="h-100 overflow" style="margin-top: -15px;">
          <!--    梯控系统-->
          <el-row :key="item.id" style="margin-left: 10px; margin-top: 10px; font-size: 0.9em"
                  v-for="item in elevatorList4.data">
            <div class="p-3"
                 style="width: 280px; height: 132px; border: 2px solid rgba(41, 155, 255, .2);border-radius: 5px;">
              <div style="margin-left: 20px;height: 90%; ">
                <div style="width: 65%">
                  <el-row style="margin-left: 75px ;font-size: 15px ">{{ item.card }}</el-row>
                  <el-row style="margin-top: 7px;">运行方向：{{ item.direction }}</el-row>
                  <el-row style="margin-top: 7px;">所在楼层：{{ item.number }}</el-row>
                  <el-row style="margin-top: 7px;">运行状态：<span :style="{ color: item.status === 'ok' ? 'rgba(0, 212, 136,1)' :
               item.status=== 'error' ? 'rgba(249, 84, 83, 1)': 'rgba(249, 227, 83, 1)' }">{{item.pointValue}}</span></el-row>
                </div>
                <img v-if=" item.status === 'ok' && item.direction === '上行'" src="../../../assets/images/comprehensive/elnormalUp.png"
                     style="margin: -90px 0px 0px 170px; ">
                <img v-if=" item.status === 'ok' && item.direction === '下行'" src="../../../assets/images/comprehensive/elevatorDonw.png"
                     style="margin: -90px 0px 0px 170px; ">
                <img v-if="item.status === 'error' " src="../../../assets/images/comprehensive/elreport.png"
                     style="margin: -90px 0px 0px 170px; ">
                <img v-if="item.status === 'maintain' " src="../../../assets/images/comprehensive/elmaintain.png"
                     style="margin: -90px 0px 0px 170px; ">
              </div>

            </div>
          </el-row>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
  </div>
</template>

<script>

export default {
  name: "Elevator",
  props: {
    spaceId: {
      type: String,
      default: () => ''
    }
  },
  inject: ['overflow'],
  data() {
    return {
      websocket: null,
      //门磁信号
      diDoorList: [],
      // 门设备列表
      AList: [], //A栋
      BList: {}, //B栋
      CList: [], //C栋
      DList: [], //D栋
      // 当前选中门的id
      currentSelectDoorId: '',

      // 获取开门记录的请求参数
      doorGetSetting: {
        command: 'getLogs',
        data: {
          max: 3,
          index: 0
        }
      },
      // 开门记录
      elevatorList: {
        "index": "0",
        "size": "4",
        "count": "3",
        "data": [{
          "id": "1",
          "card": "C1栋电梯1",
          "direction": "上行",
          "number": "10",
          "status": "ok",
          "pointValue": "正常"
        },
          {
            "id": "2",
            "card": "C1栋电梯2",
            "direction": "上行",
            "number": "10",
            "status": "error",
            "pointValue": "维修中"
          },
          {
            "id": "3",
            "card": "C1栋电梯3",
            "direction": "下行",
            "number": "10",
            "status": "maintain",
            "pointValue": "故障"
          }]
      },
      elevatorList2: {
        "index": "0",
        "size": "4",
        "count": "3",
        "data": [{
          "id": "1",
          "card": "C2栋电梯1",
          "direction": "上行",
          "number": "10",
          "status": "ok",
          "pointValue": "正常"
        },
          {
            "id": "2",
            "card": "C2栋电梯2",
            "direction": "上行",
            "number": "10",
            "status": "error",
            "pointValue": "维修中"
          },
          {
            "id": "3",
            "card": "C2栋电梯3",
            "direction": "下行",
            "number": "10",
            "status": "maintain",
            "pointValue": "故障"
          }]
      },
      elevatorList3: {
        "index": "0",
        "size": "4",
        "count": "3",
        "data": [{
          "id": "1",
          "card": "D1栋电梯1",
          "direction": "上行",
          "number": "10",
          "status": "ok",
          "pointValue": "正常"
        },
          {
            "id": "2",
            "card": "D1栋电梯2",
            "direction": "上行",
            "number": "10",
            "status": "error",
            "pointValue": "维修中"
          },
          {
            "id": "3",
            "card": "D1栋电梯3",
            "direction": "下行",
            "number": "10",
            "status": "maintain",
            "pointValue": "故障"
          }]
      },
      elevatorList4: {
        "index": "0",
        "size": "4",
        "count": "3",
        "data": [{
          "id": "1",
          "card": "D2栋电梯1",
          "direction": "上行",
          "number": "10",
          "status": "ok",
          "pointValue": "正常"
        },
          {
            "id": "2",
            "card": "D2栋电梯2",
            "direction": "上行",
            "number": "10",
            "status": "error",
            "pointValue": "维修中"
          },
          {
            "id": "3",
            "card": "D2栋电梯3",
            "direction": "下行",
            "number": "10",
            "status": "maintain",
            "pointValue": "故障"
          }]
      },
      // DI 信号的开门记录
      diDoorLogs: [],
      activeId: "1",
    }
  },
  methods: {
    // 翻页
    pageChange() {
      this.elevatorList = this.BList
    }
  },
  mounted() {
    //this.overflow()
    //this.getDoorDevices()
  }
}
</script>

<style scoped>
ul li, ul {
  padding: 0;
  float: left;
  list-style: none;
}
</style>
